export const RISK_SCORE_RATINGS = {
  VERY_POOR: 'VERY_POOR',
  POOR: 'POOR',
  FAIR: 'FAIR',
  GOOD: 'GOOD',
};
